import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LuLandingPageTypeAppResource from './LuLandingPageTypeAppResource';

export const SIZE_DESKTOP = 'desktop';
export const SIZE_TABLET = 'tablet';
export const SIZE_MOBILE = 'mobile';

class LandingPageHubPreviewAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-hub-preview';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/hubs/previews';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageTypeId',
      'screenSize',
      'addressPositionX',
      'addressPositionY',
      'streetViewPositionX',
      'streetViewPositionY',
      'fileUuid',
      'file'
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      file: FileAppResource,
      landingPageType: LuLandingPageTypeAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      file: 'file_uuid',
      landingPageType: 'landing_page_type_id',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageTypeId: {
        type: 'integer',
        presence: true,
      },
      screenSize: {
        type: 'string',
        presence: true,
      },
      fileUuid: {
        type: 'string',
      },
      addressPositionX: {
        type: 'string',
      },
      addressPositionY: {
        type: 'string',
      },
      streetViewPositionX: {
        type: 'string',
      },
      streetViewPositionY: {
        type: 'string',
      }
    };
  }

}

export default LandingPageHubPreviewAppResource;
